export default __webpack_public_path__ + "static/TPLOpreop-797daad0519691d05d2674f465a61ee5.png";